import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { RestartAlt } from "@mui/icons-material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

const ProcessingDialog = ({ open, message }) => (
  <Dialog
    open={open}
    onClose={() => {}}
    aria-labelledby="processing-dialog-title"
    maxWidth="xs"
    fullWidth
    disableEscapeKeyDown
  >
    <DialogContent>
      <MDBox display="flex" flexDirection="column" alignItems="center" py={4}>
        <MDBox
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            mb: 3,
          }}
        >
          <CircularProgress
            size={80}
            thickness={4}
            color="warning"
            sx={{
              position: "absolute",
              animationDuration: "1.5s",
            }}
          />
          <MDBox
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <RestartAlt sx={{ fontSize: 30, color: "warning" }} />
          </MDBox>
        </MDBox>

        <MDTypography variant="h6" fontWeight="bold" color="primary" gutterBottom align="center">
          {message}
        </MDTypography>

        <MDTypography variant="body2" color="secondary" align="center" sx={{ maxWidth: "80%" }}>
          Por favor, no cierres esta ventana. El proceso puede tardar unos segundos.
        </MDTypography>

        <MDBox sx={{ width: "100%", mt: 3 }}>
          <MDBox
            sx={{
              width: "100%",
              height: 4,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <MDBox
              sx={{
                height: "100%",
                width: "60%",
                backgroundColor: "warning",
                borderRadius: 2,
                animation: "pulse 2s infinite",
                "@keyframes pulse": {
                  "0%": { width: "30%", opacity: 0.7 },
                  "50%": { width: "70%", opacity: 1 },
                  "100%": { width: "30%", opacity: 0.7 },
                },
              }}
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </DialogContent>
  </Dialog>
);

ProcessingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

ProcessingDialog.defaultProps = {
  message: "Procesando...",
};

export default React.memo(ProcessingDialog);
